/* eslint-disable react/display-name */
import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { ManagementReportRouting } from './managementReport.routing';
export const ManagementReportComponent = memo(() => {
  return (
    <>
      <ManagementReportRouting />
    </>
  );
});

export const ManagementReportModule = lazyLoad(
  () => import('./managementReport.module'),
  (module) => module.ManagementReportComponent
);
